const images = [
  '/solutions/mfp/mtf.png',
  '/solutions/mfp/rebatecalc.png',
  '/solutions/mfp/validate.png',
  '/solutions/mfp/portal.png',
  '/solutions/mfp/pymts.png',
  '/solutions/mfp/communication.png',
  '/articles/mfpGp/mfpAsp.png',
  '/articles/mfpGp/minMfp340b.png',
];

export default images;
